import { render, staticRenderFns } from "./SectionsMenu.vue?vue&type=template&id=022307fa&scoped=true&"
import script from "./SectionsMenu.vue?vue&type=script&lang=js&"
export * from "./SectionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SectionsMenu.vue?vue&type=style&index=0&id=022307fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022307fa",
  null
  
)

export default component.exports